import { render, staticRenderFns } from "./PersonalInfoCard.vue?vue&type=template&id=6b8be1c6&scoped=true&"
import script from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoCard.vue?vue&type=style&index=0&id=6b8be1c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8be1c6",
  null
  
)

export default component.exports